import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TAttachment {
  id?: number;
  name: string;
  valid: boolean;
  attachmentTypeId: number;
  content: string;
  description: string;
  anonymised: boolean;
  originalAttachmentId: number;
  originalAttachmentContent: string;
  connectionType: string;
}

export interface IAttachment extends TAttachment {}

const Attachment = Model((model: TAttachment): IAttachment => {
  const _value: TAttachment = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get attachmentTypeId() {
      return _value.attachmentTypeId;
    },
    set attachmentTypeId(value) {
      _value.attachmentTypeId = value;
    },
    get content() {
      return _value.content;
    },
    set content(value) {
      _value.content = value;
    },
    get description() {
      return _value.description;
    },
    set description(value) {
      _value.description = value;
    },
    get originalAttachmentId() {
      return _value.originalAttachmentId;
    },
    set originalAttachmentId(value) {
      _value.originalAttachmentId = value;
    },
    get originalAttachmentContent() {
      return _value.originalAttachmentContent;
    },
    set originalAttachmentContent(value) {
      _value.originalAttachmentContent = value;
    },
    get anonymised() {
      return _value.anonymised;
    },
    set anonymised(value) {
      _value.anonymised = value;
    },
    get connectionType() {
      return _value.connectionType;
    },
    set connectionType(value) {
      _value.connectionType = value;
    }
  };

  return ValidatableObject<IAttachment>(_model);
});

export default Attachment;
